import { AnimationState } from "./enums";

export const DEFAULT_VALUES = {
  animationState: AnimationState.STOPED,
  activeSlide: 0,
  timerStartedAt: 0,
  timeLeft: 0,
};
